// extracted by mini-css-extract-plugin
module.exports = {"color":"DependentData_color__kks1E","marginRow":"DependentData_marginRow__rb68L","scroll":"DependentData_scroll__2Rwyo"};